const SystemStatus: React.FC = () => {
  return (
    <div className="mx-auto px-4 py-8">
      <div className="mb-8">
        <h2 className="text-2xl font-semibold mb-4">System Status</h2>
        <div className="bg-white rounded-lg shadow p-8 text-center">
          <div className="text-6xl mb-4">🚧</div>
          <h3 className="text-xl font-medium mb-2">Coming Soon</h3>
          <p className="text-gray-600">
            System status monitoring is currently under development.
          </p>
        </div>
      </div>
    </div>
  );
};

export default SystemStatus;
